import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'
import HomePage from '../pages/HomePage.vue'
import NoService from '../pages/NoService.vue'
import LandingPage from '../pages/LandingPage.vue'
import ProductList from '../pages/ProductList.vue'
import SuppliersList from '../pages/SuppliersList.vue'
import SupplierCreate from '../pages/SupplierCreate.vue'
import SupplierPage from '../pages/SupplierPage.vue'
import ProductCreate from '../pages/ProductCreate.vue'
import ExperienceCreate from '../pages/ExperienceCreate.vue'
import UnitProductCreate from '../pages/UnitProductCreate.vue'
import UnitProductPage from '../pages/UnitProductPage.vue'
import UnitExperiencePage from '../pages/UnitExperiencePage.vue'
import UnitProductPageCleaner from '../pages/UnitProductPageCleaner.vue'
import ProductPage from '../pages/ProductPage.vue'
import ExperiencePage from '../pages/ExperiencePage.vue'
import ProductCategoryList from '../pages/ProductCategoryList.vue'
import ProductCategoryCreate from '../pages/ProductCategoryCreate.vue'
import ExperienceCategoryCreate from '../pages/ExperienceCategoryCreate.vue'
import ProductCategoryPage from '../pages/ProductCategoryPage.vue'
import FrontProductPage from '../pages/FrontProductPage.vue'
import FrontExperiencePage from '../pages/FrontExperiencePage.vue'
import FrontProductList from '../pages/FrontProductList.vue'
import Dashboard from '../pages/Dashboard.vue'
import AdminPanel from '../pages/AdminPanel.vue'
import ClientList from '../pages/ClientList.vue'
import CleanerPanel from '../pages/CleanerPanel.vue'
import SupportPanel from '../pages/SupportPanel.vue'
import MyBag from '../pages/MyBag.vue'
import CheckOut from '../pages/CheckOut.vue'
import UserPage from '../pages/UserPage.vue'
import AdminProfile from '../pages/AdminProfile.vue'
import AdminMarketPlace from '../pages/AdminMarketPlace.vue'
import ClientProfile from '../pages/ClientProfile.vue'
import ClientTeam from '../pages/ClientTeam.vue'
import CleanerProfile from '../pages/CleanerProfile.vue'
import SupportProfile from '../pages/SupportProfile.vue'
import UnitList from '../pages/UnitList.vue'
import TicketList from '../pages/TicketList.vue'
import Inventory from '../pages/Inventory.vue'
import MarketPlace from '../pages/MarketPlace.vue'
import UnitListCleaner from '../pages/UnitListCleaner.vue'
import Payments from '../pages/Payments.vue'
import Deliveries from '../pages/Deliveries.vue'
import taxVerification from '../pages/TaxVerification.vue'
import UnitPage from '../pages/UnitPage.vue'
import UnitPageCleaner from '../pages/UnitPageCleaner.vue'
import SettingsAdmin from '../pages/SettingsAdmin.vue'
import SettingsClient from '../pages/SettingsClient.vue'
import SettingsCleaner from '../pages/SettingsCleaner.vue'
import SettingsSupport from '../pages/SettingsSupport.vue'
import MetricsAdmin from '../pages/MetricsAdmin.vue'
import MetricsClient from '../pages/MetricsClient.vue'
import MetricsSupport from '../pages/MetricsSupport.vue'
import MetricsCleaner from '../pages/MetricsCleaner.vue'
import UnitCreate from '../pages/UnitCreate.vue'
import Invoice from '../pages/Invoice.vue'
import GeneralTermsClient from '../pages/GeneralTermsClient.vue'
import PrivacyPolicyClient from '../pages/PrivacyPolicyClient.vue'
import GeneralTerms from '../pages/GeneralTerms.vue'
import PrivacyPolicy from '../pages/PrivacyPolicy.vue'
import CookiePolicy from '../pages/CookiePolicy.vue'
import NProgress from 'nprogress'
import store from '@/store'
import NotFound from '../pages/NotFound.vue'
import NetworkIssue from '../pages/NetworkIssue.vue'
import LogInPage from '../pages/LogInPage.vue'
import LoginNonUsers from '../pages/LoginNonUsers.vue'
import SignUpNonUser from '../pages/SignUpNonUser.vue'
import SignUpUser from '../pages/SignUpUser.vue'
import ExpiredPage from '../pages/ExpiredPage.vue'
import SwipeCards from '../pages/SwipeCards.vue'
import RestockCards from '../pages/RestockCards.vue'
import { i18n } from "../main";
import axios from 'axios';
import publicIpAddress from 'public-ip';
import ExperienceCategoryPage from '../pages/ExperienceCategoryPage.vue'


Vue.use(Router)
Vue.use(VueMeta)

const router = new Router({
  mode: 'history', //removes hash tag from URLs//
  routes: [
    {
      path: '/swipeCards/:unitId',
      name: 'swipeCards',
      component: SwipeCards,
      meta: { layout: 'HomePage' },
      props: true
    },
	{
		path: '/restockCards/:unitId',
		name: 'restockCards',
		component: RestockCards,
		meta: { layout: 'HomePage' },
		props: true
	  },
    {
      path: '/',
      name: 'landing-page',
      component: LandingPage,
      meta: { layout: 'HomePage' },
      async beforeEnter(to, from, next) {
        if (process.env.NODE_ENV === 'production') {
          window.location.href = 'https://expar.si/'
        } else {
          const publicIp = await publicIpAddress.v4()
          axios
            .get(`${process.env.VUE_APP_API_URL}/geolocate/${publicIp}`)
          .then(({ data }) => {
            sessionStorage.setItem('country-details', JSON.stringify(data))
            if(data.length > 0) {
              const lang = data[0].language
              if(!Object.keys(i18n.messages).includes(lang)) return next("en");
              if (i18n.locale !== lang) {
                i18n.locale = lang;
              }
              return next(lang);
            }
            else return next('/comingSoon/en');
          }).catch(() => {
          })
        }
      }
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: { layout: 'HomePage' },
      props: true
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      component: NetworkIssue
    },
    {
      path: '/expired',
      name: 'expired',
      component: ExpiredPage,
      meta: { layout: 'HomePage' }
    },
    {
      path: '*', //this will redirect all navigation that doesn't match to 404 page//
      redirect: { name: '404', params: { resource: 'page' } }
    },
    {
      path: '/signedOut/:lang',
      name: 'home',
      component: HomePage,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/comingSoon/:lang',
      name: 'noService',
      component: NoService,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/:lang',
      name: 'landing-page-lang',
      component: LandingPage,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const countryDetails = JSON.parse(sessionStorage.getItem('country-details'))
        if(!countryDetails || countryDetails && countryDetails.length === 0) return next({ name: 'landing-page' })
        return next()
      }
    },
    {
      path: '/dashboard/invoice',
      name: 'invoice',
      component: Invoice,
      meta: { layout: 'HomePage' }
    },
    {
      path: '/generalTerms/:lang',
      name: 'generalTerms',
      component: GeneralTerms,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/privacyPolicy/:lang',
      name: 'privacyPolicy',
      component: PrivacyPolicy,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/cookiePolicy/:lang',
      name: 'cookiePolicy',
      component: CookiePolicy,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/generalTermsExpar/:lang',
      name: 'generalTermsExpar',
      component: GeneralTermsClient,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("sl");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/privacyPolicyExpar/:lang',
      name: 'privacyPolicyExpar',
      component: PrivacyPolicyClient,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("sl");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/user/:userId',
      name: 'user',
      meta: { layout: 'frontUser', requiresAuth: true },
      component: UserPage,  
    },
    {
      path: '/dashboard/:lang',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true, clientAuth: true, adminAuth: false },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
    },
    {
      path: '/dashboard/team/:lang',
      name: 'team',
      component: ClientTeam,
      meta: { requiresAuth: true, clientAuth: true, adminAuth: false },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
    },
    {
      path: '/dashboard/add-member',
      name: 'addMember',
      component: Dashboard,
      meta: { requiresAuth: true}
    },
    {
      path: '/dashboard/settings/:lang',
      name: 'settingsClient',
      component: SettingsClient,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/dashboard/profile/:lang',
      name: 'clientProfile',
      component: ClientProfile,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/dashboard/payments/:lang',
      name: 'payments',
      component: Payments,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/dashboard/inventory/:lang',
      name: 'inventory',
      component: Inventory,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
	{
		path: '/dashboard/marketplace/:lang',
		name: 'marketplace',
		component: MarketPlace,
		meta: { requiresAuth: true},
		beforeEnter(to, from, next) {
		  const lang = to.params.lang;
		  if (!["en", "sl"].includes(lang)) return next("en");
		  if (i18n.locale !== lang) {
			i18n.locale = lang;
		  }
		  return next();
		}
	  },
    {
      path: '/dashboard/deliveries/:lang',
      name: 'deliveries',
      component: Deliveries,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/dashboard/metrics/:lang',
      name: 'metricsClient',
      component: MetricsClient,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/tax/verification/:lang',
      name: 'taxVerification',
      component: taxVerification,
      meta: { requiresAuth: true},
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/admin-panel',
      name: 'adminPanel',
      component: AdminPanel,
      meta: { requiresAuth: true, adminAuth: true, clientAuth: false, layout: 'backAdmin' }
    },
    {
      path: '/admin-panel/profile',
      name: 'adminProfile',
      component: AdminProfile,
      meta: { requiresAuth: true, adminAuth: true, clientAuth: false, layout: 'backAdmin' }
    },
    {
    path: '/admin-panel/create-client',
    name: 'adminPanelCreateClient',
    component: AdminPanel,
    meta: { layout: 'backAdmin', requiresAuth: true }
    },
    {
      path: '/admin-panel/metrics',
      name: 'metricsAdmin',
      component: MetricsAdmin,
      meta: { layout: 'backAdmin', requiresAuth: true }
      },
    {
      path: '/admin-panel/settings',
      name: 'settingsAdmin',
      component: SettingsAdmin,
      meta: { layout: 'backAdmin', requiresAuth: true}
      },
    {
    path: '/admin-panel/client-list',
    name: 'clientList',
    component: ClientList,
    meta: { requiresAuth: true, layout: 'backAdmin' }
    },
	{
		path: '/admin-panel/marketPlace-list',
		name: 'marketPlaceList',
		component: AdminMarketPlace,
		meta: { requiresAuth: true, adminAuth: true, clientAuth: false, layout: 'backAdmin' }
	},
    {
      path: '/cleaner-panel/:lang',
      name: 'cleanerPanel',
      component: CleanerPanel,
      meta: { requiresAuth: true, layout: 'backCleaner' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/cleaner-panel/profile/:lang',
      name: 'cleanerProfile',
      component: CleanerProfile,
      meta: { requiresAuth: true, layout: 'backCleaner' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/cleaner-panel/metrics',
      name: 'metricsCleaner',
      component: MetricsCleaner,
      meta: { requiresAuth: true, layout: 'backCleaner' }
    },
    {
      path: '/cleaner-panel/settings/:lang',
      name: 'settingsCleaner',
      component: SettingsCleaner,
      meta: { requiresAuth: true, layout: 'backCleaner' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/cleaner-panel/units/:lang',
      name: 'unit-list-cleaner',
      component: UnitListCleaner,
      meta: { requiresAuth: true, layout: 'backCleaner' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/cleaner-panel/units/:unitId',
      name: 'unitCleaner',
      component: UnitPageCleaner,
      meta: { requiresAuth: true, layout: 'backCleaner' },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch('unit/fetchUnit', routeTo.params.unitId)
          .then(unit => {
            routeTo.params.unit = unit
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'unit' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/cleaner-panel/units/unitProducts/:unitProductId', //!units/:unitId/:productId
      name: 'unitProductCleaner',
      component: UnitProductPageCleaner,
      props: true,
      meta: { requiresAuth: true, layout: 'backCleaner'  },
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch(
            'unitProduct/fetchUnitProduct',
            routeTo.params.unitProductId
          )
          .then(unitProduct => {
            routeTo.params.unitProduct = unitProduct
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'unitProduct' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/support-panel',
      name: 'supportPanel',
      component: SupportPanel,
      meta: { requiresAuth: true, layout: 'backSupport' }
    },
    {
      path: '/support-panel/profile',
      name: 'supportProfile',
      component: SupportProfile,
      meta: { requiresAuth: true, layout: 'backSupport' }
    },
    {
      path: '/support-panel/metrics',
      name: 'metricsSupport',
      component: MetricsSupport,
      meta: { requiresAuth: true, layout: 'backSupport' }
    },
    {
      path: '/support-panel/settings',
      name: 'settingsSupport',
      component: SettingsSupport,
      meta: { requiresAuth: true, layout: 'backSupport' }
    },
    {
      path: '/support-panel/ticket-list',
      name: 'ticket-list',
      component: TicketList,
      meta: { requiresAuth: true, layout: 'backSupport' }
    },

    {
      path: '/signup/:lang',
      name: 'register',
      component: SignUpUser,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
  	{
      path: '/register/:lang',
      name: 'registerClient',
      component: SignUpNonUser,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
	  },
  	{
      path: '/login/:lang',
      name: 'loginClient',
      component: LoginNonUsers,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
	  },
    {
      path: '/loginUser/:lang',
      name: 'loginUser',
      component: LogInPage,
      meta: { layout: 'HomePage' },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/units/:lang',
      name: 'unit-list',
      component: UnitList,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/units/create/:lang',
      name: 'unit-create',
      component: UnitCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    // EXPAR STORE DYNAMIC PATH //
    {
      path: '/unitStore/:unitUUID/product/:productUUID', //  :unitId//:productId
      name: 'unitStore',
      meta: { layout: 'frontHero' },
      component: FrontProductPage,
      props: true,
      // beforeEnter(routeTo, routeFrom, next) {
      //   store
      //     .dispatch(
      //       'unitProduct/fetchUnitProduct',
      //       routeTo.params.unitProductId
      //     )
      //     .then(unitProduct => {
      //       routeTo.params.unitProduct = unitProduct
      //       next()
      //     })
      //     .catch(error => {
      //       if (error.response && error.response.status == 404) {
      //         next({ name: '404', params: { resource: 'unitProduct' } })
      //       } else {
      //         next({ name: 'network-issue' })
      //       }
      //     })
      // }
    },
    {
      path: '/clients/products/:clientId', //  :unitId//:productId
      name: 'productList',
      meta: { layout: 'HomePage' },
      component: FrontProductList,
      props: true,
    },
    // EXPAR STORE DYNAMIC PATH //
    {
      path: '/unitStore/:unitUUID/experience/:experienceUUID', //  :unitUUID/product/:productUUID
      name: 'experience-main',
      meta: { layout: 'frontExperience' },
      component: FrontExperiencePage,
      props: true,
      // beforeEnter(routeTo, routeFrom, next) {
      //   store
      //     .dispatch(
      //       'unitProduct/fetchUnitProduct',
      //       routeTo.params.unitProductId
      //     )
      //     .then(unitProduct => {
      //       routeTo.params.unitProduct = unitProduct
      //       next()
      //     })
      //     .catch(error => {
      //       if (error.response && error.response.status == 404) {
      //         next({ name: '404', params: { resource: 'unitProduct' } })
      //       } else {
      //         next({ name: 'network-issue' })
      //       }
      //     })
      // }
    },
    //  ---------------------//
    {
      path: '/unit/:unitId',
      name: 'unit',
      component: UnitPage,
      meta: { requiresAuth: true },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch('unit/fetchUnit', routeTo.params.unitId)
          .then(unit => {
            routeTo.params.unit = unit
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'unit' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/unitProducts/create/:lang',
      name: 'unit-products-create',
      component: UnitProductCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/unit/:unitId/product/:productId',
      name: 'unitProduct',
      component: UnitProductPage,
      props: true,
      meta: { requiresAuth: true },
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch(
            'unitProduct/fetchUnitProduct',
            { unitId: routeTo.params.unitId, //! How to get unitId from UNIT page !//
            productId: routeTo.params.productId }  //! How to get productId from UNITPRODUCT CARD !//
          )
          .then(unitProduct => {
            routeTo.params.unitProduct = unitProduct
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'unitProduct' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/unit/:unitId/unitExperience/:experienceId',
      name: 'unitExperience',
      component: UnitExperiencePage,
      props: true,
      meta: { requiresAuth: true },
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch(
            'experience/fetchUnitExperience',
            { unitId: routeTo.params.unitId, //! How to get unitId from UNIT page !//
            experienceId: routeTo.params.experienceId }  //! How to get productId from UNITPRODUCT CARD !//
          )
          .then(unitExperience => {
            routeTo.params.unitExperience = unitExperience
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'unitExperience' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/products/:lang',
      name: 'product-list',
      component: ProductList,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/suppliers/:lang',
      name: 'supplier-list',
      component: SuppliersList,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/suppliers/create/:lang',
      name: 'supplier-create',
      component: SupplierCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/products/create/:lang',
      name: 'product-create',
      component: ProductCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
        {
      path: '/products/experience/create/:lang',
      name: 'experience-create',
      component: ExperienceCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/productCategories/:lang',
      name: 'product-category-list',
      component: ProductCategoryList,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/productCategories/create/:lang',
      name: 'product-categories-create',
      component: ProductCategoryCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/productCategories/experience/create/:lang',
      name: 'experience-categories-create',
      component: ExperienceCategoryCreate,
      meta: { requiresAuth: true },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["en", "sl"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      }
    },
    {
      path: '/productCategory/:productCategoryId',
      name: 'productCategory',
      component: ProductCategoryPage,
      meta: { requiresAuth: true },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch(
            'productCategory/fetchProductCategory',
            routeTo.params.productCategoryId
          )
          .then(productCategory => {
            routeTo.params.productCategory = productCategory
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'productCategory' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/experienceCategory/:productCategoryId',
      name: 'experienceCategory',
      component: ExperienceCategoryPage,
      meta: { requiresAuth: true },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch(
            'experience/fetchExperienceCategoryById',
            routeTo.params.productCategoryId
          )
          .then(productCategory => {
            routeTo.params.productCategory = productCategory
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'productCategory' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/product/:productId',
      name: 'product',
      component: ProductPage,
      meta: { requiresAuth: true },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch('product/fetchProduct', routeTo.params.productId)
          .then(product => {
            routeTo.params.product = product
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'product' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/experienceDetails/:productId',
      name: 'experience',
      component: ExperiencePage,
      meta: { requiresAuth: true },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch('experience/fetchExperienceById', routeTo.params.productId)
          .then(product => {
            routeTo.params.product = product
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'experience' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/supplier/:supplierId',
      name: 'supplier',
      component: SupplierPage,
      meta: { requiresAuth: true },
      props: true,
      beforeEnter(routeTo, routeFrom, next) {
        store
          .dispatch('supplier/fetchSupplier', routeTo.params.supplierId)
          .then(supplier => {
            routeTo.params.supplier = supplier
            next()
          })
          .catch(error => {
            if (error.response && error.response.status == 404) {
              next({ name: '404', params: { resource: 'supplier' } })
            } else {
              next({ name: 'network-issue' })
            }
          })
      }
    },
    {
      path: '/myBag',
      name: 'my-bag',
      meta: { layout: 'frontUser' },
      component: MyBag
    },
    {
      path: '/checkOut',
      name: 'checkout',
      meta: { layout: 'frontUser' },
      component: CheckOut
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.params.lang !== undefined) {
    i18n.locale = to.params.lang
  }
  if (to.name !== 'noService' && to.name !== 'unitStore' && (!to.meta.requiresAuth || to.meta.requiresAuth === false)) {
    let countryDetails = JSON.parse(sessionStorage.getItem('country-details'))
    if (!countryDetails) {
      countryDetails = await fetchCountryDetails()
    }
    if (countryDetails.length === 0) {
      next('/comingSoon/en')
    } else {
      NProgress.start()
      next()  
    }
  } else {
    NProgress.start()
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/')
  }
  next()
})

async function fetchCountryDetails() {
  const publicIp = await publicIpAddress.v4()
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.VUE_APP_API_URL}/geolocate/${publicIp}`)
    .then(({ data }) => {
      sessionStorage.setItem('country-details', JSON.stringify(data))
      return resolve(data)
    }).catch((error) => {
      return reject(error)
    })
  })
}

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     const authAccount = localStorage.getItem('user')
//     if (!authAccount || !authAccount.token) {
//       next('/login')
//     } else if (to.meta.adminAuth) {
//       const authAccount = localStorage.getItem('user')
//       if (authAccount.data.role === 'admin') {
//         next()
//       } else {
//         next('/dashboard')
//       }
//     } else if (to.meta.clientAuth) {
//       const authAccount = localStorage.getItem('user')
//       if (authAccount.data.role === 'client') {
//         next()
//       } else {
//         console.log('I am in admin panel')
//         next('/admin-panel')
//       }
//     }
//   } else {
//     next()
//   }
// })

export default router
